import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "EstadoCertificadoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "EstadoCertificadoPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexEstadoCertificado(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'EstadoCertificado', name: 'EstadoCertificado', title: 'Estado Certificado' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                //{ data: 'Rol', name: 'Rol', title: 'Rol' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            unidadAcademicas: [],
            rols: [],
            estadocertificados: [],
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            password: {},
            estadocertificado: {},
            
        };
    },
    methods: {
      
        
        newEstadoCertificado() {
            this.estadocertificado = {};
            this.$refs['frm-estadocertificado'].show();
            // console.log("hhhhola")
        },
        showEstadoCertificado(id) {
            this.isLoading=true;
            this.ss.showEstadoCertificado(id).then(
                (result) => {
                    let response = result.data;
                    this.estadocertificado = response.data;
                    this.$refs['view-estadocertificado'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editEstadoCertificado() {
            this.$refs['frm-estadocertificado'].show();
            this.$refs['view-estadocertificado'].hide();
        },
        cancelEstadoCertificado() {
            if (this.estadocertificado.id) {
                this.$refs['view-estadocertificado'].show();
            }
            this.$refs['frm-estadocertificado'].hide();
        },
        saveEstadoCertificado() {
            this.ss.storeEstadoCertificado(this.estadocertificado).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-estadocertificado'].hide();
                    this.$refs['datatable-EstadoCertificado'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteEstadoCertificado() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyEstadoCertificado(this.estadocertificado)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-estadocertificado'].hide();
                                this.$refs['datatable-EstadoCertificado'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        cambiopassword() {
            this.$refs['view-etadocesrtificado'].hide();
            this.$refs['view-password'].show();
        },
        cancelPassword() {
            this.$refs['view-password'].hide();
            this.$refs['view-estadocertificado'].show();
        },
        changePassword() {
            this.password.EstadoCertificado = this.estadocertificado.id;
            this.ss.changePassword(this.password)
                .then( result => {
                    let response = result.data;
                    if ( response.success ) {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Correcto',
                                variant: 'success',
                                autoHideDelay: 5000
                            }
                        )
                        this.$refs['view-password'].hide();
                        this.$refs['view-estadocertificado'].show();
                    } else {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Oops',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                    }
                })
                .catch( error => {
                    console.log( error );
                    this.$bvToast.toast(
                        'Error al guardar el registro',
                        {
                            title: 'Oops',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                    this.errorBag = error.data.errors;
                })
        },
        draw() {
            window.$('.btn-datatable-EstadoCertificado').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showEstadoCertificado(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } 
    }
};
